import React from "react";
import { Link } from "react-router-dom";

export default function FooterNav() {
  return (
    <div>
      <div className="eyebrow text-[hsl(var(--primary))] mb-3">Navigate</div>
      <ul className="font-display uppercase tracking-widest text-sm space-y-2">
        <li><Link to="/" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-home">Home</Link></li>
        <li><Link to="/read" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-read">The Book</Link></li>
        <li><a href="#signup" className="hover:text-[hsl(var(--primary))]" data-testid="footer-link-join">Join</a></li>
      </ul>
      <div className="mt-8 eyebrow text-[hsl(var(--primary))]">License</div>
      <p className="font-body text-sm opacity-80 mt-2 leading-relaxed">
        "This book is not copyrighted. You are asked to reproduce it
        in whole or in part." — Ken Keyes, Jr.
      </p>
    </div>
  );
}
